import KeyboardReturnOutlined from '@mui/icons-material/KeyboardReturnOutlined'
import { IntelSourceChip } from 'src/emr/intel/IntelSourceChip'

export default function ListOptionComponent({
  optionData,
  getOptionValue,
  getOptionLabel,
  isSelected,
  onClickOption,
  isSingleItemAndSupportsSelectOnEnterKeydown,
}) {
  const selected = isSelected(optionData)
  return (
    <div
      onClick={() => {
        onClickOption(optionData)
      }}
      style={{
        borderBottom: '1px solid #cecece',
        cursor: 'pointer',
        padding: '4px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      selected={selected}
    >
      <span
        style={{
          fontWeight: selected ? 600 : 400,
          fontSize: '16px',
          display: 'inline-flex',
          alignItems: 'center',
          minWidth: 0,
        }}
      >
        <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {getOptionLabel(optionData)}
        </span>
        {/* most-used / diagnosis-context tag — only EMR intel suggestions carry this */}
        {optionData?.__intelSource && <IntelSourceChip source={optionData.__intelSource} />}
      </span>
      <span>{isSingleItemAndSupportsSelectOnEnterKeydown && <KeyboardReturnOutlined />}</span>
    </div>
  )
}
